export default function AsyncNotice() {
  return (
    <div className="max-w-[720px] mx-auto mb-6 p-4 bg-card border border-border rounded-card text-[13px] text-muted-foreground leading-relaxed flex items-start gap-3" role="status">
      <svg className="w-[18px] h-[18px] flex-shrink-0 mt-0.5 text-muted-foreground" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
        <circle cx="9" cy="9" r="7"/>
        <path d="M9 5v4l2.5 2"/>
      </svg>
      <div>
        <strong className="text-foreground font-medium">You can step away any time.</strong>{' '}
        The press is patient. Reply when you have a moment, we'll save your spot.
      </div>
    </div>
  );
}
